module.exports = __webpack_public_path__ + "static/media/signage-indoor-img77.9169bb96.jpg";